var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450.15 444.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0e0e0;}.cls-10,.cls-15,.cls-2,.cls-7,.cls-9{fill:#fff;}.cls-3{fill:#ebebeb;}.cls-4{opacity:0.15;}.cls-5{fill:#ba68c8;}.cls-26,.cls-6,.cls-7{opacity:0.2;}.cls-19,.cls-8{opacity:0.1;}.cls-11,.cls-9{opacity:0.4;}.cls-10,.cls-14,.cls-21{opacity:0.3;}.cls-12{opacity:0.5;}.cls-13{opacity:0.39;}.cls-15{opacity:0.7;}.cls-16{fill:#37474f;}.cls-17{fill:#455a64;}.cls-18{isolation:isolate;}.cls-20{fill:#f0f0f0;}.cls-22{fill:#787878;}.cls-23{fill:#ffa8a7;}.cls-24{fill:#263238;}.cls-25{fill:#f28f8f;}.cls-27{opacity:0.05;}.cls-28{fill:#f5f5f5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.69,320.61l3.4,2a4.83,4.83,0,0,0,4.85,0l204.38-118a1.94,1.94,0,0,0,0-3.36l-3.47-2a4.84,4.84,0,0,0-4.88,0L47.69,317.24A1.94,1.94,0,0,0,47.69,320.61Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.34,347.1l1.17.68a1.7,1.7,0,0,0,1.69,0l70.91-40.94a.67.67,0,0,0,0-1.16l-1.2-.7a1.69,1.69,0,0,0-1.7,0l-70.87,41A.67.67,0,0,0,71.34,347.1Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467,386.86c-7.08-4.09-18.54-4.09-25.58,0s-7,10.73.08,14.82,18.55,4.09,25.59,0S474.08,391,467,386.86Z",
    transform: "translate(-43.46 -20.03)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.4,363.31l-17.16.5-17.15-.5c-.74,11.59,1.52,23.4,4.64,29.17h0a7.82,7.82,0,0,0,3.4,3.45c5.06,2.93,13.24,2.93,18.27,0a7.57,7.57,0,0,0,3.4-3.54C469.9,386.59,472.14,374.84,471.4,363.31Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M466.34,356.29c6.72,3.88,6.76,10.17.08,14s-17.55,3.88-24.27,0-6.76-10.17-.08-14S459.61,352.4,466.34,356.29Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.68,357.83c5.24,3,5.27,7.94.06,11s-13.69,3-18.93,0-5.27-7.94-.06-11S458.43,354.8,463.68,357.83Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.68,357.83c5.24,3,5.27,7.94.06,11s-13.69,3-18.93,0-5.27-7.94-.06-11S458.43,354.8,463.68,357.83Z",
    transform: "translate(-43.46 -20.03)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M482.46,290.09c-38.67,12.66-39,38.53-30.31,57,2.2,3.72,8.86,5.73,14.65-17.18l-10.16,1.3,11.84-6,3.07-9.19-9.87.73,12.53-5.27A186,186,0,0,1,482.46,290.09Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M482.46,290.09c-38.67,12.66-39,38.53-30.31,57,2.2,3.72,8.86,5.73,14.65-17.18l-10.16,1.3,11.84-6,3.07-9.19-9.87.73,12.53-5.27A186,186,0,0,1,482.46,290.09Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M482.46,290.09c-38.67,12.66-39,38.53-30.31,57,2.2,3.72,8.86,5.73,14.65-17.18l-10.16,1.3,11.84-6,3.07-9.19-9.87.73,12.53-5.27A186,186,0,0,1,482.46,290.09Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.52,296.56c-20.39,15.48-22.23,33.22-16.47,51.75C453,332,450.81,315.5,471.52,296.56Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417,316.37c38.12,5.37,42.74,29.4,37.68,48-1.42,3.84-7.29,6.81-16.49-13.57l9.68-.47-12-3.62-4.39-8.05,9.31-1-12.54-2.83A175.77,175.77,0,0,0,417,316.37Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M417,316.37c38.12,5.37,42.74,29.4,37.68,48-1.42,3.84-7.29,6.81-16.49-13.57l9.68-.47-12-3.62-4.39-8.05,9.31-1-12.54-2.83A175.77,175.77,0,0,0,417,316.37Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M417,316.37c38.12,5.37,42.74,29.4,37.68,48-1.42,3.84-7.29,6.81-16.49-13.57l9.68-.47-12-3.62-4.39-8.05,9.31-1-12.54-2.83A175.77,175.77,0,0,0,417,316.37Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.22,320.58c21.56,11,26.23,27.24,23.94,45.45C451.35,350.5,450.66,334.78,428.22,320.58Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M493.61,325.38c-34.95.57-41.81,21.71-39.33,39.05.85,3.62,5.81,6.95,16.38-10.38L462,352.54l11.24-1.92,4.86-6.76L469.8,342l11.62-1.14A158.1,158.1,0,0,1,493.61,325.38Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483,327.91c-20.67,7.52-26.68,21.62-26.66,38.29C458.8,352.29,461.18,338.2,483,327.91Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M493.61,325.38c-34.95.57-41.81,21.71-39.33,39.05.85,3.62,5.81,6.95,16.38-10.38L462,352.54l11.24-1.92,4.86-6.76L469.8,342l11.62-1.14A158.1,158.1,0,0,1,493.61,325.38Z",
    transform: "translate(-43.46 -20.03)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Windows"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.31,306.46,51,149.68a15.43,15.43,0,0,1,7-12.12L252.83,25.33c1.92-1.11,3.67-1.22,4.94-.51l-7.33-4.25h0c-1.29-.82-3.1-.75-5.1.41L50.46,133.22a15.42,15.42,0,0,0-7,12.11l.35,156.78c0,2.1.72,3.6,1.87,4.38h0a2.5,2.5,0,0,0,.39.23l7.24,4.21C52.08,310.19,51.31,308.65,51.31,306.46Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M250.44,20.57h0c-1.29-.82-3.1-.75-5.1.41L50.46,133.22a14.6,14.6,0,0,0-5.36,6l7.49,4.33a14.78,14.78,0,0,1,5.36-6L252.83,25.33c1.92-1.11,3.67-1.22,4.94-.51Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M43.46,145.33l.35,156.78c0,2.1.72,3.6,1.87,4.38h0a2.5,2.5,0,0,0,.39.23l7.24,4.21c-1.24-.74-2-2.28-2-4.47L51,149.68a14,14,0,0,1,1.64-6.16l-7.49-4.33A13.77,13.77,0,0,0,43.46,145.33Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51,158.77l.34,147.69c0,2.19.77,3.73,2,4.47a.41.41,0,0,0,.11.07l0,0c1.26.67,3,.54,4.87-.55L253.23,198.24a15.39,15.39,0,0,0,7-12.11l-.33-147.94Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M51,158.77l.34,147.69c0,2.19.77,3.73,2,4.47a.41.41,0,0,0,.11.07l0,0c1.26.67,3,.54,4.87-.55L253.23,198.24a15.39,15.39,0,0,0,7-12.11l-.33-147.94Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.87,29.35c0-2.19-.78-3.74-2-4.48a.05.05,0,0,1,0,0l-.05,0c-1.27-.71-3-.6-4.94.51L58,137.56a15.43,15.43,0,0,0-7,12.12l0,9.09L259.89,38.19Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.23,143.92c1.06-.61,1.92-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.3c-1.05.61-1.91.12-1.92-1.09A4.23,4.23,0,0,1,60.23,143.92Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.46,140.9c1.06-.61,1.91-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.31c-1.06.61-1.92.12-1.92-1.1A4.21,4.21,0,0,1,65.46,140.9Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.68,137.88c1.06-.61,1.92-.12,1.92,1.09a4.2,4.2,0,0,1-1.9,3.31c-1.06.61-1.92.12-1.92-1.1A4.2,4.2,0,0,1,70.68,137.88Z",
    transform: "translate(-43.46 -20.03)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.23,143.92c1.06-.61,1.92-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.3c-1.05.61-1.91.12-1.92-1.09A4.23,4.23,0,0,1,60.23,143.92Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.46,140.9c1.06-.61,1.91-.12,1.92,1.09a4.21,4.21,0,0,1-1.91,3.31c-1.06.61-1.92.12-1.92-1.1A4.21,4.21,0,0,1,65.46,140.9Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.68,137.88c1.06-.61,1.92-.12,1.92,1.09a4.2,4.2,0,0,1-1.9,3.31c-1.06.61-1.92.12-1.92-1.1A4.2,4.2,0,0,1,70.68,137.88Z",
    transform: "translate(-43.46 -20.03)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "155.92 152.47 183.32 136.65 183.31 133.18 155.91 149 155.92 152.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "194.91 126.48 187.16 130.96 187.17 134.43 194.92 129.95 194.91 126.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.52 168.23 207 131.58 206.99 128.11 143.51 164.76 143.52 168.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.66 171.6 137.66 168.14 129.9 172.61 129.91 176.08 137.66 171.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "151.86 151.34 114.47 172.93 114.48 176.4 151.87 154.81 151.86 151.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.3 153.52 110.54 158 110.55 161.47 118.31 156.99 118.3 153.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "109.19 179.45 109.18 175.98 84.69 190.12 84.7 193.59 109.19 179.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.37 213.85 73.38 217.32 97 203.68 96.99 200.21 73.37 213.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.08 179.45 124.07 175.98 84.72 198.7 84.73 202.17 124.08 179.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "164.64 138.84 172.4 134.36 172.39 130.89 164.63 135.37 164.64 138.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "136.13 151.83 136.13 155.29 158.63 142.31 158.62 138.84 136.13 151.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "103.21 174.31 128.78 159.54 128.77 156.07 103.2 170.84 103.21 174.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.8 178.59 95.78 175.12 73.3 188.1 73.31 191.57 95.8 178.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.59 188.58 104.91 164.73 104.9 161.26 63.58 185.12 63.59 188.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "128.68 125.21 128.67 121.74 62.71 159.82 62.72 163.29 128.68 125.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.09 141.2 86.08 137.73 62.69 151.23 62.7 154.71 86.09 141.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.82 125.24 62.66 142.65 62.67 146.13 92.83 128.71 92.82 125.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "94.1 136.58 157.59 99.93 157.57 96.45 94.09 133.1 94.1 136.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.68 111.46 100.08 121.05 100.09 124.52 116.69 114.94 116.68 111.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.27 107.85 38.92 130.57 38.93 134.04 78.28 111.32 78.27 107.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "62.84 125.36 38.95 139.15 38.96 142.62 62.85 128.83 62.84 125.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73.24 122.82 147.53 79.94 147.52 76.47 73.23 119.36 73.24 122.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "178.4 62.11 178.39 58.64 154.85 72.23 154.86 75.7 178.4 62.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.39 51.15 197.38 47.68 185.61 54.47 185.62 57.94 197.39 51.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "74.36 127.3 50.92 140.84 50.93 144.31 74.37 130.77 74.36 127.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.1 86.91 163.65 92.94 163.66 96.42 174.11 90.39 174.1 86.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "206.83 71.5 206.82 68.02 179.41 83.84 179.42 87.32 206.83 71.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "149.05 130.65 149.04 127.17 85.13 164.07 85.14 167.54 149.05 130.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "77.84 168.28 51.04 183.75 51.05 187.23 77.85 171.75 77.84 168.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "64.38 167.45 51.01 175.17 51.02 178.64 64.39 170.92 64.38 167.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "162.81 182.88 170.57 178.41 170.56 174.93 162.8 179.41 162.81 182.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "157.6 185.89 157.59 182.42 132.73 196.77 132.74 200.25 157.6 185.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "207.08 162.44 98.02 225.41 98.03 228.88 207.09 165.91 207.08 162.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "127.54 199.77 98 216.82 98 220.3 127.55 203.24 127.54 199.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73.44 239.6 73.45 243.07 92.51 232.07 92.5 228.6 73.44 239.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "92.47 220.01 62.93 237.07 62.94 240.55 92.48 223.49 92.47 220.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.41 219.53 62.91 228.49 62.91 231.96 78.42 223.01 78.41 219.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "164.64 138.84 172.4 134.36 172.39 130.89 164.63 135.37 164.64 138.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.13 151.83 136.13 155.29 158.63 142.31 158.62 138.84 136.13 151.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.21 174.31 128.78 159.54 128.77 156.07 103.2 170.84 103.21 174.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.8 178.59 95.78 175.12 73.3 188.1 73.31 191.57 95.8 178.59"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.27 107.85 38.92 130.57 38.93 134.04 78.28 111.32 78.27 107.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "62.84 125.36 38.95 139.15 38.96 142.62 62.85 128.83 62.84 125.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.24 122.82 147.53 79.94 147.52 76.47 73.23 119.36 73.24 122.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "178.4 62.11 178.39 58.64 154.85 72.23 154.86 75.7 178.4 62.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "197.39 51.15 197.38 47.68 185.61 54.47 185.62 57.94 197.39 51.15"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "149.05 130.65 149.04 127.17 85.13 164.07 85.14 167.54 149.05 130.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.84 168.28 51.04 183.75 51.05 187.23 77.85 171.75 77.84 168.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.38 167.45 51.01 175.17 51.02 178.64 64.39 170.92 64.38 167.45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.81 182.88 170.57 178.41 170.56 174.93 162.8 179.41 162.81 182.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "157.6 185.89 157.59 182.42 132.73 196.77 132.74 200.25 157.6 185.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207.08 162.44 98.02 225.41 98.03 228.88 207.09 165.91 207.08 162.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.54 199.77 98 216.82 98 220.3 127.55 203.24 127.54 199.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.44 239.6 73.45 243.07 92.51 232.07 92.5 228.6 73.44 239.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.47 220.01 62.93 237.07 62.94 240.55 92.48 223.49 92.47 220.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.41 219.53 62.91 228.49 62.91 231.96 78.42 223.01 78.41 219.53"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.48 171.77 21.5 180.36 21.48 171.77 21.48 171.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.51 183.67 28.99 179.35 28.99 179.35 21.51 183.67 21.54 192.26 21.54 192.26 21.51 183.67"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.43,
    y: 213.43,
    width: 8.64,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -140.97, 42.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.55,
    y: 256.69,
    width: 8.64,
    transform: "translate(-162.58 48.79) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.91 152.26 21.43 156.57 28.91 152.26 28.91 152.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.76 157.38 21.44 159.87 21.47 168.47 21.44 159.87 25.76 157.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.95 164.15 21.47 168.47 28.95 164.15 28.95 164.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.98 176.05 21.5 180.36 28.98 176.05 28.98 176.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.02 248.22 21.7 250.72 21.73 259.31 21.73 259.31 21.7 250.72 26.02 248.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.48,
    y: 232.9,
    width: 8.64,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -150.7, 45.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.52,
    y: 244.8,
    width: 8.64,
    transform: "translate(-156.64 47.18) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.96 167.45 21.48 171.77 21.5 180.36 28.98 176.05 28.96 167.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.54 192.26 29.02 187.94 28.99 179.35 21.51 183.67 21.54 192.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.11 222.61 21.64 226.93 21.66 235.52 29.14 231.2 29.11 222.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.69 247.41 29.17 243.09 29.15 234.5 21.67 238.82 21.69 247.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.08 210.71 21.6 215.03 21.63 223.62 29.11 219.31 29.08 210.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.94,226.58l-12.3,7.11.18,61.71,12.3-7.1Zm-2.33,27.95,0,8.6-7.48,4.31,0-8.59h0l7.48-4.32Zm-7.55-19.47h0l7.48-4.32h0l0,8.6-7.48,4.31Zm0,11.9h0l7.48-4.32h0l0,8.59-7.48,4.32Zm.09,32.38,0-8.59,4.32-2.5,3.16-1.82,0,8.59-7.48,4.32Zm0,11.89,0-8.59,7.48-4.32,0,8.59Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.75,159.53l-12.3,7.1.18,61.72,12.3-7.1ZM64.87,168l7.48-4.32,0,8.6h0l-7.48,4.32Zm0,11.89,4.31-2.49,3.17-1.82,0,8.59h0l-7.48,4.32Zm0,11.9h0l7.48-4.32,0,8.6h0L65,200.4Zm0,11.9,7.48-4.32h0l0,8.6L65,212.29h0Zm0,11.89h0l7.48-4.32h0l0,8.6L65,224.19Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M74.94,226.58l-12.3,7.11.18,61.71,12.3-7.1Zm-2.33,27.95,0,8.6-7.48,4.31,0-8.59h0l7.48-4.32Zm-7.55-19.47h0l7.48-4.32h0l0,8.6-7.48,4.31Zm0,11.9h0l7.48-4.32h0l0,8.59-7.48,4.32Zm.09,32.38,0-8.59,4.32-2.5,3.16-1.82,0,8.59-7.48,4.32Zm0,11.89,0-8.59,7.48-4.32,0,8.59Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M74.75,159.53l-12.3,7.1.18,61.72,12.3-7.1ZM64.87,168l7.48-4.32,0,8.6h0l-7.48,4.32Zm0,11.89,4.31-2.49,3.17-1.82,0,8.59h0l-7.48,4.32Zm0,11.9h0l7.48-4.32,0,8.6h0L65,200.4Zm0,11.9,7.48-4.32h0l0,8.6L65,212.29h0Zm0,11.89h0l7.48-4.32h0l0,8.6L65,224.19Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.95 164.15 28.92 155.55 25.76 157.38 21.44 159.87 21.47 168.47 28.95 164.15 28.95 164.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.29 139.5 31.28 134.71 18.98 141.81 18.99 146.6 31.29 139.5 31.29 139.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.91 152.26 28.89 143.66 21.41 147.98 21.43 156.57 28.91 152.26 28.91 152.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.02 191.24 29.02 191.24 21.55 195.56 21.55 195.56 21.57 204.15 29.05 199.84 29.02 191.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.21 254.99 29.18 246.4 26.02 248.22 21.7 250.72 21.73 259.31 21.73 259.31 29.21 254.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.74 262.61 21.76 271.2 29.24 266.88 29.21 258.29 21.74 262.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.86,104.08v-3.32a4.57,4.57,0,0,1,2.07-3.57l59.75-34.5a1.43,1.43,0,0,1,1.5-.11h0l2,1.46s-1.32.83-1.32.86l-.13,0v4.69L222.84,105.3Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M220.86,104.08v-3.32a4.57,4.57,0,0,1,2.07-3.57l59.75-34.5a1.43,1.43,0,0,1,1.5-.11h0l2,1.46s-1.32.83-1.32.86l-.13,0v4.69L222.84,105.3Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M222.84,105.3l61.91-35.75.12,42.47a4.52,4.52,0,0,1-2.05,3.57l-58.83,34,.53.67-1,1.42-2-1.46h0a1.47,1.47,0,0,1-.54-1.27l-.13-44.83Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.89,98.62a4.5,4.5,0,0,0-2.06,3.56v3.12l63.88-36.89V65.3c0-1.31-.93-1.84-2.07-1.18Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.89,98.62a4.5,4.5,0,0,0-2.06,3.56v3.12l63.88-36.89V65.3c0-1.31-.93-1.84-2.07-1.18Z",
    transform: "translate(-43.46 -20.03)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M222.84,105.3l.12,45c0,1.31.94,1.84,2.08,1.18L284.79,117a4.54,4.54,0,0,0,2.06-3.56l-.13-45Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "222.28 97.75 222.29 99.63 240.02 89.39 240.02 87.51 222.28 97.75"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "222.25 86.11 222.25 87.99 239.99 77.75 239.98 75.87 222.25 86.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "227.56 74.92 227.57 76.8 239.97 69.64 239.96 67.76 227.56 74.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "205.51 111.5 205.51 113.38 228.33 100.2 228.32 98.33 205.51 111.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "199.8 106.65 199.81 108.53 228.31 92.07 228.3 90.19 199.8 106.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "214.12 78.04 214.13 79.92 228.25 71.77 228.24 69.89 214.12 78.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "193.48 98.65 193.49 100.53 228.27 80.45 228.27 78.57 193.48 98.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "182.66 113.03 182.66 114.91 228.3 88.56 228.29 86.68 182.66 113.03"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "182.6 92.72 182.61 94.6 228.24 68.25 228.23 66.37 182.6 92.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "222.19 65.8 222.2 67.68 239.93 57.44 239.93 55.56 222.19 65.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.28 97.75 222.29 99.63 240.02 89.39 240.02 87.51 222.28 97.75"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.25 86.11 222.25 87.99 239.99 77.75 239.98 75.87 222.25 86.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "227.56 74.92 227.57 76.8 239.97 69.64 239.96 67.76 227.56 74.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "205.51 111.5 205.51 113.38 228.33 100.2 228.32 98.33 205.51 111.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "199.8 106.65 199.81 108.53 228.31 92.07 228.3 90.19 199.8 106.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "214.12 78.04 214.13 79.92 228.25 71.77 228.24 69.89 214.12 78.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "193.48 98.65 193.49 100.53 228.27 80.45 228.27 78.57 193.48 98.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "182.66 113.03 182.66 114.91 228.3 88.56 228.29 86.68 182.66 113.03"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "182.6 92.72 182.61 94.6 228.24 68.25 228.23 66.37 182.6 92.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.19 65.8 222.2 67.68 239.93 57.44 239.93 55.56 222.19 65.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.85,290.64v-3.81a5.21,5.21,0,0,1,2.37-4.1l68.58-39.59a1.65,1.65,0,0,1,1.73-.14h0l2.32,1.67s-1.51,1-1.51,1l-.16,0V251L70.11,292Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M67.85,290.64v-3.81a5.21,5.21,0,0,1,2.37-4.1l68.58-39.59a1.65,1.65,0,0,1,1.73-.14h0l2.32,1.67s-1.51,1-1.51,1l-.16,0V251L70.11,292Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M70.11,292l71.08-41,.14,48.76a5.22,5.22,0,0,1-2.37,4.09l-67.53,39,.62.77-1.13,1.62-2.31-1.67h0A1.7,1.7,0,0,1,68,342.1l-.15-51.46Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.47,284.37a5.23,5.23,0,0,0-2.37,4.09V292l73.33-42.34v-3.57c0-1.51-1.07-2.11-2.37-1.36Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.47,284.37a5.23,5.23,0,0,0-2.37,4.09V292l73.33-42.34v-3.57c0-1.51-1.07-2.11-2.37-1.36Z",
    transform: "translate(-43.46 -20.03)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M70.11,292l.15,51.69c0,1.51,1.07,2.11,2.38,1.36l68.59-39.6a5.22,5.22,0,0,0,2.36-4.09l-.15-51.7Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "30.46 312.97 30.46 315.13 50.82 303.38 50.81 301.22 30.46 312.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "30.42 299.61 30.43 301.77 50.78 290.02 50.78 287.86 30.42 299.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "30.42 290.43 30.43 292.58 44.66 284.37 44.65 282.21 30.42 290.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.7 309.01 44.71 311.16 70.9 296.04 70.89 293.89 44.7 309.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.77 299.75 44.77 301.91 77.49 283.02 77.48 280.86 44.77 299.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "43.57 277.1 43.57 279.26 59.78 269.9 59.78 267.74 43.57 277.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.79 285.84 44.8 288 84.73 264.95 84.72 262.79 44.79 285.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44.77 295.88 44.77 298.04 97.15 267.79 97.15 265.63 44.77 295.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "43.5 273.24 43.51 275.39 95.89 245.15 95.89 242.99 43.5 273.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "30.35 276.29 30.36 278.45 50.72 266.7 50.71 264.54 30.35 276.29"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.46 312.97 30.46 315.13 50.82 303.38 50.81 301.22 30.46 312.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.42 299.61 30.43 301.77 50.78 290.02 50.78 287.86 30.42 299.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.42 290.43 30.43 292.58 44.66 284.37 44.65 282.21 30.42 290.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.7 309.01 44.71 311.16 70.9 296.04 70.89 293.89 44.7 309.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.77 299.75 44.77 301.91 77.49 283.02 77.48 280.86 44.77 299.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.57 277.1 43.57 279.26 59.78 269.9 59.78 267.74 43.57 277.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.79 285.84 44.8 288 84.73 264.95 84.72 262.79 44.79 285.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.77 295.88 44.77 298.04 97.15 267.79 97.15 265.63 44.77 295.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.5 273.24 43.51 275.39 95.89 245.15 95.89 242.99 43.5 273.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.35 276.29 30.36 278.45 50.72 266.7 50.71 264.54 30.35 276.29"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "358.05 237.11 358.05 224.61 302.29 204.91 246.52 224.61 246.52 237.32 302.65 269.73 358.41 237.32 358.05 237.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "358.05 237.11 358.05 224.61 302.29 204.91 246.52 224.61 246.52 237.32 302.65 269.73 358.41 237.32 358.05 237.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "364.97 207.66 302.26 171.45 239.96 207.66 302.67 243.86 364.97 207.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "364.97 207.66 302.26 171.45 239.96 207.66 302.67 243.86 364.97 207.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "302.67 243.86 302.61 265.7 364.91 229.49 364.97 207.66 302.67 243.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "302.67 243.86 302.61 265.7 364.91 229.49 364.97 207.66 302.67 243.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "239.96 207.66 239.9 229.49 302.61 265.7 302.67 243.86 239.96 207.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "244.23 216.05 244.2 226.28 273.56 243.22 273.59 233 244.23 216.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.82,241.41l-.86-.5c-.42-.24-.76,0-.76.44v2.24a1.69,1.69,0,0,0,.75,1.32l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,290.82,241.41Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.24,243.38l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,294.24,243.38Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.66,245.36l-.85-.5c-.43-.24-.77,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,297.66,245.36Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.08,247.33l-.85-.49c-.43-.25-.76-.05-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,301.08,247.33Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.5,249.31l-.85-.5c-.43-.24-.76,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,304.5,249.31Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.92,251.28l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,307.92,251.28Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.34,253.25l-.85-.49c-.43-.24-.76,0-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,311.34,253.25Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M294.24,243.38l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,294.24,243.38Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M301.08,247.33l-.85-.49c-.43-.25-.76-.05-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,301.08,247.33Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M304.5,249.31l-.85-.5c-.43-.24-.76,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,304.5,249.31Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M311.34,253.25l-.85-.49c-.43-.24-.76,0-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,311.34,253.25Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.76,255.23l-.85-.49c-.43-.25-.76-.05-.76.43v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,314.76,255.23Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.6,271.49a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07L339,273h0A1.76,1.76,0,0,0,339.6,271.49Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.6,271.49a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07L339,273h0A1.76,1.76,0,0,0,339.6,271.49Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.85,274.2h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.61,272.61a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.67,1.67,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,272.61Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M337.61,272.61a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.67,1.67,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,272.61Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.05,265.74a5.34,5.34,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-2,1.1h0a1.73,1.73,0,0,1,1.7.18,5.31,5.31,0,0,1,2.42,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.06.15-.09h0A1.75,1.75,0,0,0,330.05,265.74Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.05,265.74a5.34,5.34,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-2,1.1h0a1.73,1.73,0,0,1,1.7.18,5.31,5.31,0,0,1,2.42,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.06.15-.09h0A1.75,1.75,0,0,0,330.05,265.74Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.3,268.45h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.06,266.86a5.31,5.31,0,0,0-2.42-4.19,1.73,1.73,0,0,0-1.7-.18,1.69,1.69,0,0,0-.74,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,328.06,266.86Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M328.06,266.86a5.31,5.31,0,0,0-2.42-4.19,1.73,1.73,0,0,0-1.7-.18,1.69,1.69,0,0,0-.74,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,328.06,266.86Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "358.05 206.63 358.05 194.13 302.29 174.44 246.52 194.13 246.52 206.84 302.65 239.25 358.41 206.84 358.05 206.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "358.05 206.63 358.05 194.13 302.29 174.44 246.52 194.13 246.52 206.84 302.65 239.25 358.41 206.84 358.05 206.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "364.97 177.18 302.26 140.97 239.96 177.18 302.67 213.39 364.97 177.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "364.97 177.18 302.26 140.97 239.96 177.18 302.67 213.39 364.97 177.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "302.67 213.39 302.61 235.22 364.91 199.01 364.97 177.18 302.67 213.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "302.67 213.39 302.61 235.22 364.91 199.01 364.97 177.18 302.67 213.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "239.96 177.18 239.9 199.01 302.61 235.22 302.67 213.39 239.96 177.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "244.23 185.57 244.2 195.8 273.56 212.75 273.59 202.52 244.23 185.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.82,210.93l-.86-.5c-.42-.24-.76,0-.76.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,290.82,210.93Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.24,212.9l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,212.9Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.66,214.88l-.85-.5c-.43-.24-.77,0-.77.44v2.25a1.69,1.69,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,297.66,214.88Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.08,216.85l-.85-.49c-.43-.25-.76-.05-.77.43V219a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.25.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,301.08,216.85Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.5,218.83l-.85-.5c-.43-.24-.76,0-.77.44V221a1.69,1.69,0,0,0,.75,1.32l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,218.83Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.92,220.8l-.85-.49c-.43-.25-.76-.05-.77.43V223a1.65,1.65,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,307.92,220.8Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.34,222.78l-.85-.5c-.43-.24-.76,0-.76.44V225a1.68,1.68,0,0,0,.76,1.32l.85.49c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,311.34,222.78Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M294.24,212.9l-.85-.49c-.43-.25-.77,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,212.9Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M301.08,216.85l-.85-.49c-.43-.25-.76-.05-.77.43V219a1.66,1.66,0,0,0,.75,1.31l.86.49c.42.25.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,301.08,216.85Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M304.5,218.83l-.85-.5c-.43-.24-.76,0-.77.44V221a1.69,1.69,0,0,0,.75,1.32l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,218.83Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M311.34,222.78l-.85-.5c-.43-.24-.76,0-.76.44V225a1.68,1.68,0,0,0,.76,1.32l.85.49c.42.24.76,0,.76-.44v-2.24A1.67,1.67,0,0,0,311.34,222.78Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.76,224.75l-.85-.49c-.43-.25-.76,0-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,314.76,224.75Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.6,241a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07.16-.08h0A1.75,1.75,0,0,0,339.6,241Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.6,241a5.31,5.31,0,0,0-2.42-4.19,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.1h0a1.76,1.76,0,0,1,1.7.19,5.3,5.3,0,0,1,2.41,4.19,1.7,1.7,0,0,1-.69,1.55l1.88-1.07.16-.08h0A1.75,1.75,0,0,0,339.6,241Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.85,243.72h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.61,242.13a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.68,1.68,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,242.13Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M337.61,242.13a5.3,5.3,0,0,0-2.41-4.19,1.76,1.76,0,0,0-1.7-.19,1.68,1.68,0,0,0-.74,1.58,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.7,1.7,0,0,0,337.61,242.13Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.05,235.27a5.36,5.36,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-2,1.11h0a1.73,1.73,0,0,1,1.7.18,5.33,5.33,0,0,1,2.42,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,235.27Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.05,235.27a5.36,5.36,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-2,1.11h0a1.73,1.73,0,0,1,1.7.18,5.33,5.33,0,0,1,2.42,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,235.27Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.3,238h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.06,236.39a5.33,5.33,0,0,0-2.42-4.2,1.73,1.73,0,0,0-1.7-.18,1.69,1.69,0,0,0-.74,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,328.06,236.39Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M328.06,236.39a5.33,5.33,0,0,0-2.42-4.2,1.73,1.73,0,0,0-1.7-.18,1.69,1.69,0,0,0-.74,1.57,5.32,5.32,0,0,0,2.43,4.19,1.73,1.73,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,328.06,236.39Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "358.05 176.15 358.05 163.65 302.29 143.96 246.52 163.65 246.52 176.36 302.65 208.77 358.41 176.36 358.05 176.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "358.05 176.15 358.05 163.65 302.29 143.96 246.52 163.65 246.52 176.36 302.65 208.77 358.41 176.36 358.05 176.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "364.97 146.7 302.26 110.5 239.96 146.7 302.67 182.91 364.97 146.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "364.97 146.7 302.26 110.5 239.96 146.7 302.67 182.91 364.97 146.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "302.67 182.91 302.61 204.74 364.91 168.54 364.97 146.7 302.67 182.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "302.67 182.91 302.61 204.74 364.91 168.54 364.97 146.7 302.67 182.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "239.96 146.7 239.9 168.54 302.61 204.74 302.67 182.91 239.96 146.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "244.23 155.1 244.2 165.32 273.56 182.27 273.59 172.05 244.23 155.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.82,180.45,290,180c-.42-.24-.76,0-.76.44v2.25A1.68,1.68,0,0,0,290,184l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,290.82,180.45Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.24,182.42l-.85-.49c-.43-.25-.77-.05-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,182.42Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.66,184.4l-.85-.5c-.43-.24-.77,0-.77.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,297.66,184.4Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.08,186.37l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,301.08,186.37Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.5,188.35l-.85-.5c-.43-.24-.76,0-.77.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,188.35Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.92,190.32l-.85-.49c-.43-.25-.76-.05-.77.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,307.92,190.32Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.34,192.3l-.85-.5c-.43-.24-.76,0-.76.44v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,192.3Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M294.24,182.42l-.85-.49c-.43-.25-.77-.05-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,294.24,182.42Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M301.08,186.37l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,301.08,186.37Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M304.5,188.35l-.85-.5c-.43-.24-.76,0-.77.44v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,188.35Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M311.34,192.3l-.85-.5c-.43-.24-.76,0-.76.44v2.25a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,192.3Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.76,194.27l-.85-.49c-.43-.25-.76-.05-.76.43v2.25a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.25A1.67,1.67,0,0,0,314.76,194.27Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.6,210.54a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.11h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,210.54Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.6,210.54a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l-1.95,1.11h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,210.54Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.85,213.24h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.61,211.66a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,337.61,211.66Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M337.61,211.66a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,337.61,211.66Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.05,204.79a5.36,5.36,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.73,1.73,0,0,1,1.7.18,5.33,5.33,0,0,1,2.42,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,204.79Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.05,204.79a5.36,5.36,0,0,0-2.42-4.2,1.71,1.71,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.73,1.73,0,0,1,1.7.18,5.33,5.33,0,0,1,2.42,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.74,1.74,0,0,0,330.05,204.79Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.3,207.49h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.06,205.91a5.33,5.33,0,0,0-2.42-4.2,1.73,1.73,0,0,0-1.7-.18,1.69,1.69,0,0,0-.74,1.57,5.36,5.36,0,0,0,2.43,4.2,1.73,1.73,0,0,0,1.67.19h0l.05,0A1.69,1.69,0,0,0,328.06,205.91Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M328.06,205.91a5.33,5.33,0,0,0-2.42-4.2,1.73,1.73,0,0,0-1.7-.18,1.69,1.69,0,0,0-.74,1.57,5.36,5.36,0,0,0,2.43,4.2,1.73,1.73,0,0,0,1.67.19h0l.05,0A1.69,1.69,0,0,0,328.06,205.91Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "358.05 145.67 358.05 133.17 302.29 113.48 246.52 133.17 246.52 145.88 302.65 178.29 358.41 145.88 358.05 145.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "358.05 145.67 358.05 133.17 302.29 113.48 246.52 133.17 246.52 145.88 302.65 178.29 358.41 145.88 358.05 145.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "364.97 116.22 302.26 80.02 239.96 116.22 302.67 152.43 364.97 116.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "364.97 116.22 302.26 80.02 239.96 116.22 302.67 152.43 364.97 116.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "302.67 152.43 302.61 174.26 364.91 138.06 364.97 116.22 302.67 152.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "302.67 152.43 302.61 174.26 364.91 138.06 364.97 116.22 302.67 152.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "239.96 116.22 239.9 138.06 302.61 174.26 302.67 152.43 239.96 116.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "244.23 124.62 244.2 134.84 273.56 151.79 273.59 141.57 244.23 124.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.82,150l-.86-.49c-.42-.25-.76,0-.76.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,290.82,150Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.24,151.94l-.85-.49c-.43-.24-.77,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,294.24,151.94Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.66,153.92l-.85-.49c-.43-.25-.77-.05-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,297.66,153.92Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.08,155.89l-.85-.49c-.43-.24-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,301.08,155.89Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.5,157.87l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,157.87Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.92,159.84l-.85-.49c-.43-.25-.76,0-.77.43V162a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44v-2.25A1.69,1.69,0,0,0,307.92,159.84Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.34,161.82l-.85-.5c-.43-.24-.76,0-.76.44V164a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,161.82Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M294.24,151.94l-.85-.49c-.43-.24-.77,0-.77.44v2.24a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,294.24,151.94Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M301.08,155.89l-.85-.49c-.43-.24-.76,0-.77.43v2.25a1.66,1.66,0,0,0,.75,1.31l.86.5c.42.24.76,0,.76-.44v-2.24A1.71,1.71,0,0,0,301.08,155.89Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M304.5,157.87l-.85-.49c-.43-.25-.76,0-.77.43v2.25a1.68,1.68,0,0,0,.75,1.31l.86.49c.42.24.76,0,.76-.43v-2.25A1.67,1.67,0,0,0,304.5,157.87Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M311.34,161.82l-.85-.5c-.43-.24-.76,0-.76.44V164a1.66,1.66,0,0,0,.76,1.31l.85.49c.42.24.76.05.76-.43v-2.25A1.67,1.67,0,0,0,311.34,161.82Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.76,163.79l-.85-.49c-.43-.25-.76-.05-.76.43V166a1.65,1.65,0,0,0,.76,1.31l.85.5c.42.24.76,0,.76-.44V165.1A1.67,1.67,0,0,0,314.76,163.79Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.6,180.06a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l0,0-1.95,1.1h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,180.06Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.6,180.06a5.33,5.33,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.19h0l0,0-1.95,1.1h0a1.73,1.73,0,0,1,1.7.18,5.32,5.32,0,0,1,2.41,4.2,1.69,1.69,0,0,1-.69,1.54l1.88-1.06.16-.09h0A1.74,1.74,0,0,0,339.6,180.06Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M336.85,182.76h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.61,181.18a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,337.61,181.18Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M337.61,181.18a5.32,5.32,0,0,0-2.41-4.2,1.73,1.73,0,0,0-1.7-.18,1.65,1.65,0,0,0-.74,1.57,5.31,5.31,0,0,0,2.42,4.19,1.74,1.74,0,0,0,1.67.2h0l.05,0A1.69,1.69,0,0,0,337.61,181.18Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.05,174.31a5.37,5.37,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.71,1.71,0,0,1,1.7.19,5.31,5.31,0,0,1,2.42,4.19,1.68,1.68,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.73,1.73,0,0,0,330.05,174.31Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.05,174.31a5.37,5.37,0,0,0-2.42-4.2,1.74,1.74,0,0,0-1.69-.18h0l0,0-2,1.1h0a1.71,1.71,0,0,1,1.7.19,5.31,5.31,0,0,1,2.42,4.19,1.68,1.68,0,0,1-.69,1.54l1.88-1.06.15-.09h0A1.73,1.73,0,0,0,330.05,174.31Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M327.3,177h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.06,175.43a5.31,5.31,0,0,0-2.42-4.19,1.71,1.71,0,0,0-1.7-.19,1.69,1.69,0,0,0-.74,1.57,5.36,5.36,0,0,0,2.43,4.2,1.73,1.73,0,0,0,1.67.19h0l.05,0A1.68,1.68,0,0,0,328.06,175.43Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M328.06,175.43a5.31,5.31,0,0,0-2.42-4.19,1.71,1.71,0,0,0-1.7-.19,1.69,1.69,0,0,0-.74,1.57,5.36,5.36,0,0,0,2.43,4.2,1.73,1.73,0,0,0,1.67.19h0l.05,0A1.68,1.68,0,0,0,328.06,175.43Z",
    transform: "translate(-43.46 -20.03)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M369.83,276.54H377s8.32,54.63,8.89,65.1a.92.92,0,0,1-.54.75,2.84,2.84,0,0,1-2.57,0,.9.9,0,0,1-.5-.65h0C381.24,335.49,369.83,276.54,369.83,276.54Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M377,276.54s.36,2.35.92,6.13c-1.14,2.46-3.62,5.14-5.89,5.19-.89-4.59-2.19-11.32-2.19-11.32Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M377.86,322.35H370.7s-8.32,54.63-8.9,65.11a.89.89,0,0,0,.54.74,2.8,2.8,0,0,0,2.58,0,.93.93,0,0,0,.5-.65h0C366.45,381.3,377.86,322.35,377.86,322.35Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M370.7,322.35s-.36,2.35-.93,6.14a18.89,18.89,0,0,0,6.63,1.38c.89-4.6,1.46-7.52,1.46-7.52Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M409.1,298.69h7.16s8.32,54.63,8.9,65.1a1,1,0,0,1-.54.75,2.86,2.86,0,0,1-2.58,0,1,1,0,0,1-.5-.65h0C420.51,357.64,409.1,298.69,409.1,298.69Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M416.26,298.69s.36,2.35.93,6.13c-1.14,2.46-3.63,5.14-5.9,5.19-.89-4.59-2.19-11.32-2.19-11.32Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M335.48,297.94h-7.16S320,352.57,319.43,363a.92.92,0,0,0,.54.75,2.84,2.84,0,0,0,2.57,0,.89.89,0,0,0,.5-.66h0C324.07,356.89,335.48,297.94,335.48,297.94Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M328.32,297.94s-.36,2.35-.92,6.13c1.22,1.45,3.9,3.68,6.18,3.73.88-4.59,1.9-9.86,1.9-9.86Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "370.29 230.13 367.16 269.95 370.98 272.83 374.41 231.81 370.29 230.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "329.92 207.34 326.78 247.17 330.61 250.04 334.04 209.02 329.92 207.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M363.73,262s-23.93,6.74-42.37,24.47v7.26c3.4,4.08,29.29,24.25,56.5,32.62C396,318,414,304,417.13,300.12v-7.26C410.29,279.49,363.73,262,363.73,262Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M321.36,286.5v7.26c3.4,4.08,29.29,24.25,56.5,32.62v-7.26C350.65,310.75,324.76,290.58,321.36,286.5Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.86,319.12v7.26C396,318,414,304,417.13,300.12v-7.26C414,296.69,396,310.75,377.86,319.12Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M426.71,242a3.07,3.07,0,0,0-.47-1.62c-15.95-25-49-32.72-56.34-30.83L366.48,213v17.93c25.5,3.24,47.37,19.87,56.2,32.69l1.18-.46a4.53,4.53,0,0,0,2.86-4.2V242Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M426.71,242a3.17,3.17,0,0,1-2.08,3l-1.95.7v17.92l1.18-.46a4.53,4.53,0,0,0,2.86-4.2V242Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M422.68,245.7l1.95-.7a3.17,3.17,0,0,0,2.08-3,3.07,3.07,0,0,0-.47-1.62c-15.95-25-49-32.72-56.34-30.83L366.48,213C373.83,211.65,410.17,218.91,422.68,245.7Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M366.48,213v17.93c25.5,3.24,47.37,19.87,56.2,32.69V245.7C410.17,218.91,373.83,211.65,366.48,213Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.74,405.48l1,5.94c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.06-9.25,0-11.53-1.25,2.77-4,4.64-5.7,7.2A14.44,14.44,0,0,0,318.74,405.48Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M317.22,410.78l2.51.64-1-5.94C318.12,407.19,317.71,409,317.22,410.78Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.74,405.48l1,5.94c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.06-9.25,0-11.53-1.25,2.77-4,4.64-5.7,7.2A14.44,14.44,0,0,0,318.74,405.48Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M317.22,410.78l2.51.64-1-5.94C318.12,407.19,317.71,409,317.22,410.78Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.21,388.54a24.47,24.47,0,0,0-1.95-4.53,13,13,0,0,1-2.18,6.84c-1.7,2.73-4,5.09-5.59,7.86-2,3.38-3,7.36-5.61,10.28a12.33,12.33,0,0,1-10.27,4,5.42,5.42,0,0,1-3.76-1.69,2.94,2.94,0,0,1-.62-1.79,27.63,27.63,0,0,1-4.23,3.71c-1.72,1.19-3.77,2.45-4.05,4.52a4.43,4.43,0,0,0,2.46,4.21,11.58,11.58,0,0,0,5,1.12,31.69,31.69,0,0,0,11-.94,15.31,15.31,0,0,0,8.81-6.39,19.73,19.73,0,0,0,2-5c.49-1.78.9-3.59,1.52-5.3a14.44,14.44,0,0,1,1.54-3.16c1.71-2.56,4.45-4.43,5.7-7.2.07-.15.15-.29.21-.44A9.84,9.84,0,0,0,326.21,388.54Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M300.61,413a12.33,12.33,0,0,0,10.27-4c2.6-2.92,3.63-6.9,5.61-10.28,1.63-2.77,3.89-5.13,5.59-7.86a13,13,0,0,0,2.18-6.84c.46-1.77,1.36-3.87,1.16-4.25-4.88-.43-8.13-1.65-13.6-2.42a245.2,245.2,0,0,1-9.62,23.52,37.67,37.67,0,0,1-6,8.65,2.94,2.94,0,0,0,.62,1.79A5.42,5.42,0,0,0,300.61,413Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M332.71,352.28c-.6,9.45-3,16.29-4.86,29.18,0,0-11.31,3.37-18.36-1.55l-.29-19.85Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M283.46,391.85l1,5.93c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.07-9.25,0-11.53-1.25,2.77-4,4.65-5.7,7.2A14.33,14.33,0,0,0,283.46,391.85Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282,397.14l2.5.64-1-5.93C282.85,393.55,282.44,395.37,282,397.14Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.46,391.85l1,5.93c4.71-2.24,6.23-4.77,6.23-4.77.12-4.56.07-9.25,0-11.53-1.25,2.77-4,4.65-5.7,7.2A14.33,14.33,0,0,0,283.46,391.85Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M282,397.14l2.5.64-1-5.93C282.85,393.55,282.44,395.37,282,397.14Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.93,374.9a23.77,23.77,0,0,0-1.94-4.53,13,13,0,0,1-2.19,6.84c-1.69,2.74-4,5.09-5.58,7.87-2,3.37-3,7.35-5.62,10.28a12.3,12.3,0,0,1-10.26,4,5.39,5.39,0,0,1-3.76-1.69,3,3,0,0,1-.63-1.79,26.72,26.72,0,0,1-4.23,3.71c-1.71,1.2-3.77,2.45-4.05,4.53a4.45,4.45,0,0,0,2.46,4.21,11.59,11.59,0,0,0,5,1.12,32,32,0,0,0,11-.95,15.29,15.29,0,0,0,8.8-6.39,19.76,19.76,0,0,0,2-5c.49-1.77.9-3.59,1.51-5.29a14.33,14.33,0,0,1,1.55-3.17c1.7-2.55,4.45-4.43,5.7-7.2a4.28,4.28,0,0,0,.2-.44A9.77,9.77,0,0,0,290.93,374.9Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M265.34,399.35a12.3,12.3,0,0,0,10.26-4c2.61-2.93,3.63-6.91,5.62-10.28,1.62-2.78,3.89-5.13,5.58-7.87a13,13,0,0,0,2.19-6.84c.45-1.77,1.36-3.87,1.15-4.25-4.88-.43-8.13-1.65-13.59-2.42a245.27,245.27,0,0,1-9.63,23.52,37.46,37.46,0,0,1-6,8.65,3,3,0,0,0,.63,1.79A5.39,5.39,0,0,0,265.34,399.35Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M301,341.21c-2.18,9.21-5.72,15.55-9.72,27.94,0,0-11.73,1.41-17.84-4.64l5.26-32.35Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M372.79,315.67c6.76-2.91,37.39-18.16,17.12-47.76l-50.25-7.21c-1.65,15.77-16.14,26.1-16.14,26.1Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M362.72,277.07a54.59,54.59,0,0,0,27.19-9.16,70.8,70.8,0,0,0-7.77-11.15l-44.86,4q-.66,5.58-1,11A54.6,54.6,0,0,0,362.72,277.07Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M334.59,198.39a9.22,9.22,0,0,1,.09-3.55c.23-1,3.07-7,2.69-7.38a14.92,14.92,0,0,1-1.8-18.74,5,5,0,0,1,.91-9.65c1.81-.31,3.62.38,5.43.77a26.17,26.17,0,0,0,9.34,0c3.09-.45,6.17-1.12,9.29-1.35a18.83,18.83,0,0,1,9.2,1.31,10.27,10.27,0,0,1,5.95,6.83c4.63-.91,10,2.87,10.86,7.51s-1.82,9-1.41,13.57a15.12,15.12,0,0,0,4,8.24c2,2.35,4.41,4.35,6.51,6.62a37.27,37.27,0,0,1,9.79,22.9c.28,4.76-.44,9.75-3.1,13.71-5.22,7.78-19.23,9.73-27.84,9.4a45.88,45.88,0,0,1-24.6-8.33c-5-3.5-9.51-8.71-9.33-14.78.08-2.86,1.2-5.56,2-8.32s1.13-5.83-.2-8.36-4.3-4.1-6.08-6.49A8.86,8.86,0,0,1,334.59,198.39Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M346.86,221.42a7.42,7.42,0,0,0,4.8,1.28,26.86,26.86,0,0,0,21.41-10.62l-4.76-.42v-15.3l-16.53,6.38v8.84h-4.24a12.4,12.4,0,0,0-2,3.59C344.8,217.32,345.11,220,346.86,221.42Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M367.15,196.8c-2.68,6.06-8,11.26-15.37,12.12v-6.18Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M365.37,184.58a15.22,15.22,0,0,0-.18,3.87,4.56,4.56,0,0,0,1.28,2.59,2.87,2.87,0,0,0,2.61.77,5.05,5.05,0,0,1,9.81-2.4,6.33,6.33,0,0,1-1.06,5.26,11.83,11.83,0,0,1-4.22,3.52,4.29,4.29,0,0,1-5.1-2c-4.91,6.23-13.48,10.9-21.51,10.23a11.48,11.48,0,0,1-6.11-2.15c-3-2.35-3.26-5.9-3.64-9.4a49.73,49.73,0,0,1,.1-13.35c1-6.1,3.7-12.1,8.44-16.07C348.54,178.72,360.71,183.6,365.37,184.58Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "305.19 163.03 299.69 169.81 304.8 171.57 305.19 163.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M353,194.9l-4.28,1.36a2.65,2.65,0,0,0,2.9,1.31A2.39,2.39,0,0,0,353,194.9Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M353,194.9l-4.28,1.36a2.65,2.65,0,0,0,2.9,1.31A2.39,2.39,0,0,0,353,194.9Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M350.17,197.49a2.44,2.44,0,0,0,1.41.08,2.18,2.18,0,0,0,1.38-1.95,2.58,2.58,0,0,0-1.66.31A2.53,2.53,0,0,0,350.17,197.49Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M356.22,184.48a1.53,1.53,0,1,1-1.46-1.6A1.54,1.54,0,0,1,356.22,184.48Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M343.44,183.41a1.53,1.53,0,1,1-1.46-1.6A1.52,1.52,0,0,1,343.44,183.41Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M342.23,177.27l-3.49,2.19a2.2,2.2,0,0,1,.77-2.37A2.58,2.58,0,0,1,342.23,177.27Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M355.29,177.68l3.28,2.49a2.2,2.2,0,0,0-.55-2.43A2.58,2.58,0,0,0,355.29,177.68Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M391.79,268.62c-8.54-12.84-9.05-21.83-4.79-29.41,1.3-2.3,1.08-11.58.71-18.37a8.66,8.66,0,0,0-7.91-8.18l-6.73-.58a26.86,26.86,0,0,1-21.41,10.62c-2.5,0-5.26-.45-6.26-3.51a5.73,5.73,0,0,1-.21-2.63,10.6,10.6,0,0,1,2.35-5h-4.11c-4.94,4.39-14.28,22.16-14.86,31.72-.29,4.8,3.41,7.16,6,8.65,0,0,1.74,7.08-.85,20.22C346.3,281.07,375.67,282,391.79,268.62Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.86,243.22a17.78,17.78,0,0,1-21.37,6.28,13.21,13.21,0,0,0,12.2,3.4C366,251.81,369.59,247.43,370.86,243.22Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M368.31,210.19v1.47l-8.13,34S361,263.64,371.87,284c12.32,2.32,22.26-4.42,24.87-7.77-7.46-10.16-12.4-30-12.4-30l-1.27-33.43-13.77-.95Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M368.31,211.66v-1.47l3.89,6.94a2.16,2.16,0,0,1-.28,2.5l-4.38,4.9,2.25,2.14a2.17,2.17,0,0,1,.36,2.7l-10,16.32Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M368.31,211.66v-1.47l3.89,6.94a2.16,2.16,0,0,1-.28,2.5l-4.38,4.9,2.25,2.14a2.17,2.17,0,0,1,.36,2.7l-10,16.32Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.18,219.31l-9.38,40.86-1.95.7.85-5.53a143.63,143.63,0,0,1,10.48-36Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.39,266.8l1.88-13.89c-1.25-4-1.93-6.75-1.93-6.75l-.3-7.72-16.93,35.29c.62,1.54,1.29,3.11,2,4.72L375,277.1A12.27,12.27,0,0,0,384.39,266.8Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M335.72,274.24c-.06-11.46,0-24.76,1.13-32.14,3.69-16.63,8.51-22.85,12.61-30.52h2.32v-2.66l-3.68,2.66h-4.67c-16.94,19.95-16.86,30.93-17,34.11s.51,23.49.51,23.49Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M342,216a2.19,2.19,0,0,0-.89,1.93l.31,4-3.85,1.5a2.18,2.18,0,0,0-1.38,2.16l1,15.12c3.64-15.56,8.3-21.66,12.28-29.11h2.32v-2.66Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342,216a2.19,2.19,0,0,0-.89,1.93l.31,4-3.85,1.5a2.18,2.18,0,0,0-1.38,2.16l1,15.12c3.64-15.56,8.3-21.66,12.28-29.11h2.32v-2.66Z",
    transform: "translate(-43.46 -20.03)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "133.87 265.35 133.87 362.96 137.32 360.96 137.32 263.35 133.87 265.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "133.87 265.35 133.87 362.96 130.42 360.96 130.42 263.35 133.87 265.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "137.32 291.38 218.11 244.74 218.11 241.03 137.32 287.67 137.32 291.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "137.32 283.75 214.65 239.03 218.11 241.03 137.32 287.67 137.32 283.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "359.19 298.23 359.19 395.84 362.64 393.84 362.64 296.23 359.19 298.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "359.19 298.23 359.19 395.84 355.74 393.84 355.74 296.23 359.19 298.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "274.95 346.88 274.95 444.49 278.4 442.5 278.4 344.88 274.95 346.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "274.95 346.88 274.95 444.49 271.5 442.5 271.5 344.88 274.95 346.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "278.4 372.91 359.19 326.27 359.19 322.56 278.4 369.2 278.4 372.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "278.4 365.28 355.74 320.56 359.19 322.56 278.4 369.2 278.4 365.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "359.19 298.23 359.19 395.84 362.64 393.84 362.64 296.23 359.19 298.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "359.19 298.23 359.19 395.84 355.74 393.84 355.74 296.23 359.19 298.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "274.95 346.88 274.95 444.49 278.4 442.5 278.4 344.88 274.95 346.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "274.95 346.88 274.95 444.49 271.5 442.5 271.5 344.88 274.95 346.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "278.4 372.91 359.19 326.27 359.19 322.56 278.4 369.2 278.4 372.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "278.4 365.28 355.74 320.56 359.19 322.56 278.4 369.2 278.4 365.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.87 265.35 133.87 362.96 137.32 360.96 137.32 263.35 133.87 265.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.87 265.35 133.87 362.96 130.42 360.96 130.42 263.35 133.87 265.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.32 291.38 218.11 244.74 218.11 241.03 137.32 287.67 137.32 291.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.32 283.75 214.65 239.03 218.11 241.03 137.32 287.67 137.32 283.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "274.95 337.45 130.41 254.21 218.1 203.56 362.64 286.81 274.95 337.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "274.95 346.88 130.41 263.35 130.41 254.21 274.95 337.45 274.95 346.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "274.95 337.44 362.64 286.79 362.64 296.23 274.95 346.88 274.95 337.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "274.95 337.45 130.41 254.21 218.1 203.56 362.64 286.81 274.95 337.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "274.95 337.44 362.64 286.79 362.64 296.23 274.95 346.88 274.95 337.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "274.95 346.88 130.41 263.35 130.41 254.21 274.95 337.45 274.95 346.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M325.7,332a16.65,16.65,0,0,0-15.09,0c-4.15,2.42-4.13,6.33.05,8.74a16.59,16.59,0,0,0,15.09,0C329.9,338.33,329.88,334.42,325.7,332Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.32,316.82l-11.46.33-11.47-.33c-.49,7.74,1,15.63,3.1,19.49h0a5.21,5.21,0,0,0,2.27,2.31,13.47,13.47,0,0,0,12.21,0,5.05,5.05,0,0,0,2.27-2.37C328.32,332.37,329.82,324.52,329.32,316.82Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.94,312.12c4.49,2.6,4.52,6.8.05,9.4s-11.72,2.59-16.22,0-4.51-6.8,0-9.4S321.45,309.53,325.94,312.12Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.16,313.15c3.51,2,3.53,5.31,0,7.33a13.9,13.9,0,0,1-12.65,0c-3.5-2-3.52-5.3,0-7.33A14,14,0,0,1,324.16,313.15Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.16,313.15c3.51,2,3.53,5.31,0,7.33a13.9,13.9,0,0,1-12.65,0c-3.5-2-3.52-5.3,0-7.33A14,14,0,0,1,324.16,313.15Z",
    transform: "translate(-43.46 -20.03)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.9,317.14a7.53,7.53,0,0,0,6.73,1.53,7.05,7.05,0,0,0,4.71-4.76,13.69,13.69,0,0,1-3.68-2.56,9.44,9.44,0,0,1,5.21.19,5.29,5.29,0,0,0,.39-5,9.08,9.08,0,0,0-6.21-.43,8.26,8.26,0,0,1,6.28-2,24.05,24.05,0,0,0-1.51-9.65c-4.27.22-8.42,2.06-9.82,3.39a15.81,15.81,0,0,0,.48,4.54,3.69,3.69,0,0,1-2-2.94c-2.67.67-3.82,2-4.24,3a11.29,11.29,0,0,0,2.54,5.13,6.18,6.18,0,0,1-3.53-3.56C309.79,309.94,310.26,316.57,316.9,317.14Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.9,317.14a7.53,7.53,0,0,0,6.73,1.53,7.05,7.05,0,0,0,4.71-4.76,13.69,13.69,0,0,1-3.68-2.56,9.44,9.44,0,0,1,5.21.19,5.29,5.29,0,0,0,.39-5,9.08,9.08,0,0,0-6.21-.43,8.26,8.26,0,0,1,6.28-2,24.05,24.05,0,0,0-1.51-9.65c-4.27.22-8.42,2.06-9.82,3.39a15.81,15.81,0,0,0,.48,4.54,3.69,3.69,0,0,1-2-2.94c-2.67.67-3.82,2-4.24,3a11.29,11.29,0,0,0,2.54,5.13,6.18,6.18,0,0,1-3.53-3.56C309.79,309.94,310.26,316.57,316.9,317.14Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M316.9,317.14a7.53,7.53,0,0,0,6.73,1.53,7.05,7.05,0,0,0,4.71-4.76,13.69,13.69,0,0,1-3.68-2.56,9.44,9.44,0,0,1,5.21.19,5.29,5.29,0,0,0,.39-5,9.08,9.08,0,0,0-6.21-.43,8.26,8.26,0,0,1,6.28-2,24.05,24.05,0,0,0-1.51-9.65c-4.27.22-8.42,2.06-9.82,3.39a15.81,15.81,0,0,0,.48,4.54,3.69,3.69,0,0,1-2-2.94c-2.67.67-3.82,2-4.24,3a11.29,11.29,0,0,0,2.54,5.13,6.18,6.18,0,0,1-3.53-3.56C309.79,309.94,310.26,316.57,316.9,317.14Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M316.75,317.78h0a.26.26,0,0,1-.23-.27c.41-5.4,3.5-14.31,10.87-21.66a.23.23,0,0,1,.34,0,.24.24,0,0,1,0,.35c-7.26,7.25-10.31,16-10.71,21.35A.25.25,0,0,1,316.75,317.78Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.77,320a7,7,0,0,1-11-2.88,11.92,11.92,0,0,0,3.33-2.27,9.48,9.48,0,0,0-4.93.15,4.58,4.58,0,0,1-.69-4.43,9,9,0,0,1,5.87-.35,8.74,8.74,0,0,0-6.09-1.81,19.6,19.6,0,0,1,.82-8.62c4.08.25,8.11,1.94,9.51,3.13a12.9,12.9,0,0,1-.16,4,2.93,2.93,0,0,0,1.68-2.59c2.56.62,3.71,1.81,4.16,2.72a8.93,8.93,0,0,1-2.06,4.53,5.05,5.05,0,0,0,3.09-3.13C325,313.69,324.94,319.54,318.77,320Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M318.77,320a7,7,0,0,1-11-2.88,11.92,11.92,0,0,0,3.33-2.27,9.48,9.48,0,0,0-4.93.15,4.58,4.58,0,0,1-.69-4.43,9,9,0,0,1,5.87-.35,8.74,8.74,0,0,0-6.09-1.81,19.6,19.6,0,0,1,.82-8.62c4.08.25,8.11,1.94,9.51,3.13a12.9,12.9,0,0,1-.16,4,2.93,2.93,0,0,0,1.68-2.59c2.56.62,3.71,1.81,4.16,2.72a8.93,8.93,0,0,1-2.06,4.53,5.05,5.05,0,0,0,3.09-3.13C325,313.69,324.94,319.54,318.77,320Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.93,320.62a.25.25,0,0,1-.24-.21c-.7-4.7-4.12-12.5-11.44-19a.25.25,0,0,1,0-.35.24.24,0,0,1,.35,0c7.42,6.6,10.89,14.53,11.6,19.32a.25.25,0,0,1-.21.28Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.22,270.75l34.07-19.81a7.77,7.77,0,0,1,7,0L344.5,283.4a2.53,2.53,0,0,1,1.45,1.92h0v2.16h0a1.68,1.68,0,0,1,0,.45.09.09,0,0,0,0,.05,2.15,2.15,0,0,1-.24.48l0,.05a2.58,2.58,0,0,1-.42.47l0,0a3.81,3.81,0,0,1-.62.45l-34.08,19.8a5.1,5.1,0,0,1-1,.43c-.12.05-.24.08-.37.12s-.33.09-.5.12-.4.08-.6.1l-.15,0a7.55,7.55,0,0,1-.83,0h-.13c-.28,0-.56,0-.83,0l-.12,0a7,7,0,0,1-.8-.14l-.14,0a6.75,6.75,0,0,1-.68-.21l-.13,0a4.71,4.71,0,0,1-.75-.36L247.23,276.8a5.52,5.52,0,0,1-.64-.45l-.16-.18a4.2,4.2,0,0,1-.29-.32,2.26,2.26,0,0,1-.11-.22,2,2,0,0,1-.17-.32c0-.07,0-.15,0-.23a1.64,1.64,0,0,1,0-.32v-2A2.46,2.46,0,0,1,247.22,270.75Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M346,285.32a1.84,1.84,0,0,1-.06.62.09.09,0,0,0,0,.05,1.9,1.9,0,0,1-.24.47l0,.05a2.29,2.29,0,0,1-.42.47l0,0a3.81,3.81,0,0,1-.62.45l-34.08,19.8a5.81,5.81,0,0,1-1,.43l-.37.11-.5.13c-.2,0-.4.08-.6.1l-.15,0c-.27,0-.55,0-.83.05h-.13a7.55,7.55,0,0,1-.83-.05H306a7,7,0,0,1-.8-.14l-.14,0a6.75,6.75,0,0,1-.68-.21l-.13,0a5.77,5.77,0,0,1-.75-.36L247.23,274.8a4.53,4.53,0,0,1-.64-.45c-.06-.05-.1-.11-.16-.17a4.28,4.28,0,0,1-.29-.33,2.12,2.12,0,0,1-.11-.21,2.48,2.48,0,0,1-.17-.32c0-.08,0-.15,0-.23a1.77,1.77,0,0,1,0-.32v2a1.64,1.64,0,0,0,0,.32c0,.08,0,.16,0,.23a2,2,0,0,0,.17.32,2.26,2.26,0,0,0,.11.22,4.2,4.2,0,0,0,.29.32l.16.18a5.52,5.52,0,0,0,.64.45l56.22,32.45a4.71,4.71,0,0,0,.75.36l.13,0a6.75,6.75,0,0,0,.68.21l.14,0a7,7,0,0,0,.8.14l.12,0c.27,0,.55,0,.83,0H307a7.55,7.55,0,0,0,.83,0l.15,0c.2,0,.4-.06.6-.1s.34-.08.5-.12.25-.07.37-.12a5.1,5.1,0,0,0,1-.43l34.08-19.8a3.81,3.81,0,0,0,.62-.45l0,0a2.58,2.58,0,0,0,.42-.47l0-.05a2.15,2.15,0,0,0,.24-.48.09.09,0,0,1,0-.05,1.68,1.68,0,0,0,0-.45h0v-2.16Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.55,272.77l54.61,31.53.22.11.11,0c.11,0,.21.07.43.12a2.73,2.73,0,0,0,.3.06l.21,0a3.7,3.7,0,0,0,.53,0H307a4,4,0,0,0,.56,0l.35-.06.45-.12a1.51,1.51,0,0,0,.37-.15l17.57-10.22L269.9,261.52Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M307,304.68h0Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.5,264.1l-10.27,6a1,1,0,0,0,0,1.8l15.36,8.87a1.73,1.73,0,0,0,1.72,0l10.27-6a1,1,0,0,0,0-1.8l-15.37-8.87A1.71,1.71,0,0,0,302.5,264.1Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.55,272.77l54.61,31.53.22.11.11,0c.11,0,.21.07.43.12a2.73,2.73,0,0,0,.3.06l.21,0a3.7,3.7,0,0,0,.53,0H307a4,4,0,0,0,.56,0l.35-.06.45-.12a1.51,1.51,0,0,0,.37-.15l17.57-10.22L269.9,261.52Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.5,264.1l-10.27,6a1,1,0,0,0,0,1.8l15.36,8.87a1.73,1.73,0,0,0,1.72,0l10.27-6a1,1,0,0,0,0-1.8l-15.37-8.87A1.71,1.71,0,0,0,302.5,264.1Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M327.85,272.94c-3.12,4.21-.55,10.84,3.47,11.6C338.1,280.71,333.26,273.57,327.85,272.94Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M313.45,274.57l-6.31,2.75a1.59,1.59,0,0,0-.95,1.6h0a1.59,1.59,0,0,0,1.58,1.45h6Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M322.53,275.51l-5.62-2.61a3.74,3.74,0,0,0-4.18.7l-4,3.83a3.11,3.11,0,0,0-.94,1.95l-.4,4.09A1.48,1.48,0,0,0,308.5,285h0a1.48,1.48,0,0,0,1.83-1.28l.35-3.58,2.09-2.33-1.15,1.79a2.72,2.72,0,0,0-.44,1.59l.1,3.08a2.62,2.62,0,0,0,1.49,2.28l4.87,2.33a2.61,2.61,0,0,0,2.59-.19,21.29,21.29,0,0,0,2.12-1.63,1.33,1.33,0,0,0,.18-1.4l2.23-1.62,44.94-7.69-10.83-14.07Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M322.53,285.7a5.07,5.07,0,0,1-3.09.52,9,9,0,0,0,.11-3.05,4.37,4.37,0,0,1,.9,2.31A3,3,0,0,0,322.53,285.7Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M383.07,212.73a8.5,8.5,0,0,0-8.89,6.58l-9.38,40.86-5.93,2.15-31,10.62c5.28,4,3.47,11.6,3.47,11.6l38.38-8.15a16.32,16.32,0,0,0,13.26-13l7.85-40.57A8.5,8.5,0,0,0,383.07,212.73Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M364.8,260.17c4.14,0,7.39,4.28,7.8,5.86.81-8.35-4-8.68-7.46-7.34Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M341.16,211.53a27.09,27.09,0,0,0-18.49,6.72L299.35,238.7a21.68,21.68,0,0,0-3.91,4.53l-12.16,18.83,12.19,8.09,13-18.79L327.61,238c1.63-5.77,5.67-14.5,15.82-26.46Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.7,242.16l5.91-4.12c1.29-4.58,4.12-11,10.29-19.47A55.7,55.7,0,0,0,321.7,242.16Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238,231.05h0l1.35-.67h0a1.66,1.66,0,0,1,1.51.09l56.6,32.91a6.82,6.82,0,0,1,3.32,4.85l5.82,37a1.69,1.69,0,0,1-.95,1.79h0l-1.3.64h0a1.65,1.65,0,0,1-1.46-.12l-56.6-32.91A6.82,6.82,0,0,1,243,269.8l-5.82-37A1.68,1.68,0,0,1,238,231.05Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.91,264.92a12.51,12.51,0,0,1,5.62,8.09c.37,2.89-1.54,4-4.28,2.38a12.56,12.56,0,0,1-5.62-8.1C264.26,264.41,266.18,263.34,268.91,264.92Z",
    transform: "translate(-43.46 -20.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M305.48,305.81l-5.82-37a6.82,6.82,0,0,0-3.32-4.85l-56.6-32.91a1.69,1.69,0,0,0-1.7,0h0l1.35-.67h0a1.66,1.66,0,0,1,1.51.09l56.6,32.91a6.82,6.82,0,0,1,3.32,4.85l5.82,37a1.69,1.69,0,0,1-.95,1.79h0l-1.3.64h0A1.71,1.71,0,0,0,305.48,305.81Z",
    transform: "translate(-43.46 -20.03)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.f08d33795ba924201d30989ed9bea553.svg";
export { ForwardRef as ReactComponent };